import { FormField, fieldA11y } from '@/components/FormField';
import { Input } from '@/components/ui/input';
import type { ProfileFormApi } from './useProfileForm';

/** No provider named (SPEC decision 23): the queue is the build queue, whichever service runs it. */
const TIMEOUT_HINT = 'Includes the time the build waits in the build queue: give it a few hours when the queue is long (up to 720)';

export function ProfileTimeout({ form }: { form: ProfileFormApi }) {
  const error = form.errorFor('timeoutMinutes', true);
  return (
    <FormField id="profile-timeout" label="Timeout (min)" required hint={TIMEOUT_HINT} error={error}>
      <Input data-testid="profile-timeout" type="number" min={5} max={720} value={form.values.timeout} onChange={(e) => form.patch({ timeout: e.target.value })} className="font-mono sm:max-w-40 sm:text-[13px]" {...fieldA11y('profile-timeout', error, 'profile-timeout-hint')} />
    </FormField>
  );
}
